<div class="main-page">
  <app-header></app-header>
  <div class="container">
      <ngx-spinner></ngx-spinner>
      <div class="plans-area">
          <div class="innerPage plans-area-inner">
              <div class="plan-card">
              <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                        <button class="mainSub btn  text-center" (click)="redirectTo('/mysubscration')">Base Paid Subscription Plan</button>
                        <div class="mTop10 d-flex justify-content-center">Recurring Fees</div>
                  </div>
                  
              </div>
              <div class="row" style="margin-top:50px;">
                <div class="col-lg-6 col-md-6 col-sm-12">
                      <button class="paddingTop25 addOn btn  text-center" (click)="redirectTo('/my-banner-plans')"><span class="mTop15">Banner <br><span class="banner">(Subscription Model)</span></span></button>
                      <div class="container subscribe">
                        <div>
                            <div >
                                <div class="card subscription cost Scollable">
                                    <div class="card-body">
                                        <div>
                                            <h6>Recurring Fees</h6>
                                            <h6>Fee = Banner Size and Range</h6>
                                            <div class="mTop25">50%. Discount for 
                                          </div>
                                        <ul>
                                        <li>Community Builder Plan </li>
                                        <li>Founder Plan</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                       </div>

                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <button class="addOn btn  text-center" (click)="redirectTo('/advertisements')">Ads</button>
                    <div class="container subscribe">
                      <div class="card subscription cost Scollable">
                        <div class="card-body">
                          <div>
                              <h6>One-time Fee</h6>
                              <h6>Fee = Ad Duration and Range<br>  (With a Recurring Option)</h6>
                              <div >50%. Discount for 
                            </div>
                          <ul>
                          <li>Community Builder Plan </li>
                          <li>Founder Plan</li>
                        </ul>
                      </div>
                    </div>
                      </div>
                     </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>